import React from 'react';
import FormWizard from './components/FormWizard';
import './styles/FormWizard.css';

function App() {
  return (
    <div className="app-container">
      <FormWizard />
    </div>
  );
}

export default App;